import { EditPageTemplate } from "../../EditPageTemplate";
import { mt } from "../../../../utils/tracking";
import { useState } from "react";
import { UpdateStatus } from "../../ContactInfo.types";

import { usePolicySummaries } from "../../../../hooks/usePolicySummaries";
import { NotFound } from "../../../../not-found";
import { useScrollToTop } from "../../../../hooks/useScrollToTop";
import {
  useEmail,
  useIsStateFarmPartitioned,
} from "../../../../app/Providers/AppContext";
import {
  DocumentDeliverySelection,
  DocumentDeliverySelectionState,
  DocumentDeliveryValue,
} from "./components/DocumentDeliverySelection";
import { navigateToSettings } from "../../utils";
import { PaperlessTermsModal } from "./components/PaperlessTermsModal";

const PAPERLESS_TERMS_MODAL_ID = "paperless-terms-modal";

export default function DocumentDeliveryPage() {
  const isStateFarmPartitioned = useIsStateFarmPartitioned();

  if (isStateFarmPartitioned) {
    return <NotFound />;
  }

  useScrollToTop();

  const policies = usePolicySummaries();
  const hasUsCorePolicy = policies?.some(
    (p) => p.source === "CORE" && p.country === "USA"
  );

  if (!hasUsCorePolicy) {
    return <NotFound />;
  }

  // TODO: update "currentDeliveryMethod" with correct value
  return <DocumentDeliveryPageWrapped currentDeliveryMethod="mail" />;
}

type DocumentDeliveryPageWrappedProps = {
  /** The user's current document delivery preference. */
  currentDeliveryMethod: DocumentDeliveryValue;
};

const DocumentDeliveryPageWrapped = ({
  currentDeliveryMethod,
}: DocumentDeliveryPageWrappedProps) => {
  const email = useEmail();
  const [updateStatus, setUpdateStatus] = useState<UpdateStatus>("ok");
  const [state, setState] = useState<
    DocumentDeliverySelectionState | undefined
  >();

  return (
    <>
      <EditPageTemplate
        heading="Document delivery"
        message="Control how you receive your billing alerts and policy statements.
          Embrace the efficiency of paperless communication or continue
          receiving paper documents in your mailbox."
        unsavedChangesDialogHeading="Save document delivery changes?"
        pending={updateStatus == "pending"}
        isFormDirty={!!state && state.selectedOption !== currentDeliveryMethod}
        hasValidationErrors={
          state?.selectedOption === "paperless" && !state?.emailValid
        }
        showMutateError={updateStatus === "mutateError"}
        onClickSave={onClickSave}
      >
        <DocumentDeliverySelection
          initialOption={currentDeliveryMethod}
          defaultEmail={email}
          termsModalId={PAPERLESS_TERMS_MODAL_ID}
          onChange={setState}
        />
      </EditPageTemplate>
      <PaperlessTermsModal id={PAPERLESS_TERMS_MODAL_ID} />
    </>
  );

  async function onClickSave(): Promise<void> {
    mt.trackAction({ actionType: "button", actionName: "save" });
    setUpdateStatus("pending");

    // TODO: call bff to update paperless status

    setTimeout(() => navigateToSettings(true), 2000);
  }
};
